<template>
    <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
        <!-- title and search bar -->
        <div class="flex flex-row items-center justify-between mb-4">
            <p class="text-3xl font-bold">Member Category</p>
            <BaseRoundedButton @click="handleSlideOver">
                <p class="font-sans">Create New Member Category</p>
            </BaseRoundedButton>
        </div>
        <!-- body -->
        <div>
            <table class="table-auto w-full font-light">
                <thead class="border-b-2 border-light-gray">
                    <tr class="text-left text-gray text-md">
                        <th class="py-2 font-normal">Category Name</th>
                        <th class="py-2 font-normal">Description</th>
                        <th class="py-2 font-normal text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="category in categories" :key="category.id" class="text-lg border-b border-light-gray">
                        <td class="px-4 align-top">
                            {{ category.name }}
                        </td>
                        <td class="px-2 truncate-2-lines align-top text-gray">
                            {{ category.description }}
                        </td>
                        <td>
                            <div class="flex justify-center relative">
                                <Menu>
                                    <MenuButton>
                                        <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                                    </MenuButton>
                                    <MenuItems
                                        class=" p-1 space-y-1 absolute top-8 right-0 z-50  bg-white border border-light-gray shadow-md rounded-lg w-12/12">
                                        <MenuItem @click="handleUpdate(category)"
                                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                                        <div class="flex flex-row items-center px-4 py-2 min-w-min">
                                            <PencilIcon class="text-blue w-5 h-5 mr-4" />
                                            <p class="text-blue">Edit</p>
                                        </div>
                                        </MenuItem>
                                        <MenuItem @click="handleDelete(category.id)"
                                            class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                                        <div class="flex flex-row items-center px-4 py-2 min-w-min">
                                            <TrashIcon class="text-red w-5 h-5 mr-4" />
                                            <p class="text-red">Delete</p>
                                        </div>
                                        </MenuItem>
                                    </MenuItems>
                                </Menu>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <SideBar v-show="showSideBar" @close-modal="handleCloseSideBar">
        <div class="w-full h-full flex flex-col content-between">
            <!-- header -->
            <div>
                <h1 v-if="!updateFlag" class="text-blue text-2xl">Create New Member Category</h1>
                <h1 v-else class="text-blue text-2xl">Update Member Category</h1>
            </div>
            <div class="my-4 h-full flex flex-col space-y-4">
                <BaseTextInput v-model="title" name="title" isAutoComplete="off" label="Member Category Name" />
                <div class="flex flex-col h-full space-y-2">
                    <p class="text-gray">Description</p>
                    <textarea class="max-h-full h-3/6 min-h-24 px-2 py-3 border border-gray rounded-lg" name="description"
                        v-model="description"></textarea>
                </div>
            </div>
            <div v-if="errorMsg" class="p-4 my-2 bg-light-red rounded-lg">
                <p class="text-red">{{ this.errorMsg }}</p>
            </div>
            <div v-if="updateFlag" class=" flex flex-row items-center justify-between space-x-4 mt-auto mb-4 ">
                <BaseRoundedButton @click="handleCloseSideBar" class="bg-dark-gray w-2/6">
                    <p>Cancel</p>
                </BaseRoundedButton>
                <BaseRoundedButton @click="handleSaveUpdate" class="w-4/6">
                    <p>Save Update</p>
                </BaseRoundedButton>
            </div>
            <BaseRoundedButton v-else @click="handleCreate">
                <p>Create</p>
            </BaseRoundedButton>
        </div>
    </SideBar>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { PencilIcon, EllipsisVerticalIcon, TrashIcon } from "@heroicons/vue/24/outline";
import userService from "../Services/user.service";
import SideBar from "../components/SideBar.vue";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import { useToast } from "vue-toastification";
import BaseTextInput from "../components/BaseTextInput.vue";
import moment from "moment";
export default {
    name: "MemberCategory",
    components: {
        Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        PencilIcon,
        EllipsisVerticalIcon,
        SideBar,
        BaseRoundedButton,
        BaseTextInput,
        TrashIcon,
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            categories: [],
            showSideBar: false,
            updateFlag: false,
            title: "",
            description: "",
            id: "",
            errorMsg: "",
        };
    },
    methods: {
        handleGetCategories() {
            userService.getMemberCategory().then(
                (response) => {
                    this.categories = response.data.data;
                    this.$Progress.finish();
                },
            );
        },
        handleSlideOver() {
            this.showSideBar = true;
        },
        handleUpdate(category) {
            this.showSideBar = true;
            this.updateFlag = true;
            this.title = category.name;
            this.description = category.description;
            this.id = category.id;
        },
        handleCloseSideBar() {
            this.showSideBar = false;
            this.updateFlag = false;
            this.description = "";
            this.id = "";
            this.title = "";
            this.errorMsg = "";
        },
        handleCreate() {
            this.$Progress.start();
            let formData = new FormData();
            formData.append("name", this.title);
            formData.append("description", this.description);

            userService.storeCreateMemberCategory(formData).then(
                () => {
                    this.$Progress.finish();
                    this.handleGetCategories();
                    this.handleCloseSideBar();
                    this.toast.success("Member Category Created Successfully");
                },
            ).catch((error) => {
                this.$Progress.fail();
                this.errorMsg = (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
            });
        },
        handleSaveUpdate() {
            this.$Progress.start();
            let formData = new FormData();
            formData.append("name", this.title);
            formData.append("description", this.description);

            userService.storeUpdateMemberCategory(this.id, formData).then(
                () => {
                    this.$Progress.finish();
                    this.handleGetCategories();
                    this.handleCloseSideBar();
                    this.toast.success("Member Category Updated Successfully");
                },
            ).catch((error) => {
                this.$Progress.fail();
                this.errorMsg = (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
            })
        },
        handleDelete(id) {
            this.$Progress.start();
            userService.delMemberCategory(id).then(
                () => {
                    this.$Progress.finish();
                    this.handleGetCategories();
                    this.toast.success("Member Category Deleted Successfully");
                },
            ).catch((error) => {
                this.$Progress.fail();
                let errorToast = (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                this.toast.error(errorToast);
            })
        },
    },
    created() {
        this.$Progress.start();
        this.handleGetCategories();
        this.moment = moment;
    },
}
</script>

<style scoped>
.truncate-2-lines {
    max-height: 3.6em;
    /* double the size of line-height */
    line-height: 1.8em;
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: hidden;
}
</style>